import { getAppData } from "app/getAppData";
import {
  setPuzzelOrgConfig,
  setPuzzelRuntimeConfig,
} from "app/PuzzelAuth/puzzelAuthConfig";
import { Amplify } from "aws-amplify";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const {
    authUrl,
    clientId,
    userPoolId,
    puzzelClientId,
    puzzelIdpScheme,
    puzzelCiqType,
    puzzelPhoneNumberPrefix,
    puzzelFunctionalNumberPrefix,
    puzzelCountryCode,
    puzzelMaxAttempts,
    puzzelMaxOneRequestForPreferredAgent,
    puzzelPreferredAgentWaitTimeSeconds,
    puzzelQueueKey,
    puzzelReservedAgentWaitTimeSeconds,
    puzzelSecondsBetweenAttempts,
    cognitoSettings,
    puzzelSettings,
  } = await getAppData();

  setPuzzelRuntimeConfig({
    clientId: puzzelSettings?.clientId ?? puzzelClientId,
    idpScheme: puzzelSettings?.idpScheme ?? puzzelIdpScheme,
  });

  setPuzzelOrgConfig({
    ciqType: puzzelSettings?.ciqType ?? puzzelCiqType,
    phoneNumberPrefix:
      puzzelSettings?.phoneNumberPrefix ?? puzzelPhoneNumberPrefix,
    functionalNumberPrefix:
      puzzelSettings?.functionalNumberPrefix ?? puzzelFunctionalNumberPrefix,
    countryCode: puzzelSettings?.countryCode ?? puzzelCountryCode,
    maxAttempts: puzzelSettings?.maxAttempts ?? puzzelMaxAttempts,
    maxOneRequestForPreferredAgent:
      puzzelSettings?.maxOneRequestForPreferredAgent ??
      puzzelMaxOneRequestForPreferredAgent,
    preferredAgentWaitTimeSeconds:
      puzzelSettings?.preferredAgentWaitTimeSeconds ??
      puzzelPreferredAgentWaitTimeSeconds,
    queueKey: puzzelSettings?.queueKey ?? puzzelQueueKey,
    reservedAgentWaitTimeSeconds:
      puzzelSettings?.reservedAgentWaitTimeSeconds ??
      puzzelReservedAgentWaitTimeSeconds,
    secondsBetweenAttempts:
      puzzelSettings?.secondsBetweenAttempts ?? puzzelSecondsBetweenAttempts,
  });

  const cognitoAuthUrl = cognitoSettings?.authUrl ?? authUrl;
  const cognitoClientId = cognitoSettings?.clientId ?? clientId;
  const cognitoUserPoolId = cognitoSettings?.userPoolId ?? userPoolId;

  if (!cognitoAuthUrl || !cognitoClientId || !cognitoUserPoolId) {
    throw new Error("Missing Cognito configuration in app-data");
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: cognitoAuthUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId: cognitoUserPoolId,
        userPoolClientId: cognitoClientId,
      },
    },
  });

  isConfigured = true;
};
